const Error = ({ errorMsg }) => {
  console.log(errorMsg);
	return <h1>{errorMsg}</h1>;
};

export default Error;
